<rotec-modal-v2 width="510px" [darkMode]="true" title="Language">
  <ng-container ngProjectAs="modal-main">
    <div class="language-container">
      <div
        class="language-button"
        [class.selected]="selectedLanguage === 'en'"
        (click)="changeLanguage('en')"
      >
        <div class="flag-icon flag-icon-gb"></div>
        <span translate>English</span>
      </div>
      <div
        class="language-button"
        [class.selected]="selectedLanguage === 'de'"
        (click)="changeLanguage('de')"
      >
        <div class="flag-icon flag-icon-de"></div>
        <span translate>German</span>
      </div>
    </div>
  </ng-container>

  <ng-container ngProjectAs="modal-buttons">
    <button rotec-button-secondary dark (click)="close()" translate>
      {{ 'Cancel' | translate }}
    </button>
    <button rotec-button-active dark (click)="apply()" [disabled]="buttonDisabled">
      {{ 'Apply' | translate }}
    </button>
  </ng-container>
</rotec-modal-v2>
